/**
 * Wie viele Aufnahmen ein Bogen braucht und wohin dafür gescrollt wird.
 *
 * Reine Rechnung, damit sie prüfbar ist: kein DOM, kein Gerät. Die Regel ist „möglichst
 * wenige Bilder, die zusammen alles zeigen" — nicht „gleichmäßig verteilt".
 */

/** Unterhalb dieser Zahl gilt ein Rest als Rundungsfehler und nicht als weitere Kachel. */
const TOLERANZ_PX = 2;

/**
 * Die Scroll-Positionen, an denen aufgenommen wird.
 *
 * ⚠️ **Die letzte Kachel springt ans Ende, nicht auf ihr Vielfaches.** Bei 1000 px Inhalt und
 * 400 px Sichthöhe wären die Vielfachen 0, 400, 800 — die dritte Aufnahme zeigte dann 200 px
 * Inhalt und 200 px Leere. Stattdessen: 0, 400, 600. Die letzte überlappt die vorige, dafür
 * ist jedes Bild voll. Überlappung schadet einem Beweisdokument nicht, ein halb leeres Bild
 * am Ende sieht dagegen nach Fehler aus.
 */
export function planTiles(scrollHeight: number, clientHeight: number): number[] {
  if (clientHeight <= 0) return [0];
  if (scrollHeight <= clientHeight + TOLERANZ_PX) return [0];

  const anzahl = Math.ceil(scrollHeight / clientHeight);
  const letzteMögliche = scrollHeight - clientHeight;

  const stellen: number[] = [];
  for (let i = 0; i < anzahl; i += 1) {
    stellen.push(Math.min(i * clientHeight, letzteMögliche));
  }

  // Ein Vielfaches kann mit der ans Ende gezogenen letzten Kachel zusammenfallen; dann ist
  // die Aufnahme dieselbe und eine davon überflüssig.
  return stellen.filter((wert, i) => i === 0 || wert !== stellen[i - 1]);
}
